import View from "../nav/views/FlashSaleCounterView";
import components from "./components.js";
components.define("js-flashSale", View);